import { Close } from "@platzi/icons";
import classNames from "classnames/bind";
import styles from "./Tag.module.sass";

interface Props {
  index: number;
  tag: {
    value: string;
    isValid: boolean;
    isDuplicate?: boolean;
  };
  handleTagRemove: (tag: number) => void;
}

export const Tag = ({ index, tag, handleTagRemove }: Props) => {
  const cx = classNames.bind(styles);

  const tagStyles = cx("Tag", {
    "--error": !tag.isValid || tag.isDuplicate,
  });

  return (
    <div className={tagStyles}>
      {tag.value}
      <button className="remove-button" onClick={() => handleTagRemove(index)}>
        <Close />
      </button>
    </div>
  );
};
